import { render, staticRenderFns } from "./InventoryViewDashboard.vue?vue&type=template&id=24e4f7aa&scoped=true&"
import script from "./InventoryViewDashboard.vue?vue&type=script&lang=ts&"
export * from "./InventoryViewDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryViewDashboard.vue?vue&type=style&index=0&id=24e4f7aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4f7aa",
  null
  
)

export default component.exports